import { Button, Empty, Modal } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import PendingAuthService from "../services/approvals.service";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { amountFormat } from "../services/common.service";
import UploadHistoryGrid from "./upload-history-grid";
import UploadHistoryList from "./upload-history-list";

export default function UploadHistory({ dataSource = [] }) {
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState({});
  const { t } = useTranslation();
  const location = useLocation();
  const isPathBulk = location.pathname.includes("/bulk-payment-upload/history");
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const handleSingleRcordDownload = useCallback(
    async (selected) => {
      try {
        const reqParams = {
          reqId: selected.reqId,
          module: "FILEUPLOAD",
        };
        await PendingAuthService.fileSingleUploadDownload(
          reqParams,
          selected?.file
        );
      } catch (err) {}
    },
    [details]
  );

  return (
    <>
      {showGridAccount === "GRID" && (
        <UploadHistoryGrid
          handleSingleRcordDownload={handleSingleRcordDownload}
          dataSource={dataSource}
          setDetails={setDetails}
          setVisible={setVisible}
        />
      )}
      {showGridAccount === "LIST" && (
        <UploadHistoryList
          handleSingleRcordDownload={handleSingleRcordDownload}
          dataSource={dataSource}
          setDetails={setDetails}
          setVisible={setVisible}
        />
      )}

      <Modal
        title={""}
        open={visible}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {" "}
          {t("common.transaction_details", {
            defaultValue: "Transaction Details",
          })}
        </h3>

        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.pending_approval.file_name", {
                    defaultValue: "File Name",
                  })}
                </span>
                <p className="value-receipt">{details?.file}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.upload.process_name", {
                    defaultValue: "Process Name",
                  })}
                </span>
                <p className="value-receipt">{details?.processName}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.upload.file_process_start_date", {
                    defaultValue: "File Process Start Date",
                  })}{" "}
                </span>
                <p className="value-receipt">
                  {details?.fileProcessStartTime
                    ? moment(details?.fileProcessStartTime).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.upload.file_process_end_date", {
                    defaultValue: "File Process End Date",
                  })}
                </span>
                <p className="value-receipt">
                  {details?.fileProcessEndTime
                    ? moment(details?.fileProcessEndTime).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("pages.upload.file_process_data_start_date", {
                    defaultValue: "File Process Data Start Date",
                  })}
                </div>
                <p className="value-receipt">
                  {details?.fileDataProcessStartTime
                    ? moment(details?.fileDataProcessStartTime).format(
                        "DD-MM-YYYY"
                      )
                    : "-"}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.upload.file_process_data_end_date", {
                    defaultValue: "File Process Data End Date",
                  })}
                </span>
                <p className="value-receipt">
                  {details?.fileDataProcessEndTime
                    ? moment(details?.fileDataProcessEndTime).format(
                        "DD-MM-YYYY"
                      )
                    : "-"}
                </p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.my_accounts.common_my_accounts.value_date", {
                    defaultValue: "Value Date",
                  })}
                </span>
                <p className="value-receipt">{details?.valueDate}</p>
              </div>

              {isPathBulk ? null : (
                <>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                    <span className="lbl-receipt">
                      {t("pages.gepeg.source_account", {
                        defaultValue: "Source Account",
                      })}
                    </span>
                    <p className="value-receipt">{details?.srcAccNo}</p>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                    <span className="lbl-receipt">
                      {t("pages.pending_approval.source_acc_currency", {
                        defaultValue: "Source Account Currency",
                      })}
                    </span>
                    <p className="value-receipt">{details?.srcAccCcy}</p>
                  </div>
                </>
              )}
              {isPathBulk ? null : (
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <div className="lbl-receipt">
                    {" "}
                    {t("pages.landing.total_amount", {
                      defaultValue: "Total Amount",
                    })}{" "}
                  </div>
                  <p className="value-receipt">
                    {amountFormat(details?.totalAmount) || "-"}
                  </p>
                </div>
              )}
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {" "}
                  {t("pages.upload.transaction_count", {
                    defaultValue: "Transaction Count",
                  })}{" "}
                </div>
                <p className="value-receipt">{details?.totalRecCount || "-"}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {" "}
                  {t("common.status", { defaultValue: "Status" })}{" "}
                </div>
                <p className="value-receipt">{details?.status || "-"}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.remarks", { defaultValue: "Reason" })}{" "}
                </div>
                <p className="value-receipt">{details?.remarks}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <Button
            onClick={() => setVisible(false)}
            className="secondary-btn"
            type="default"
            size="large"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
